import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbDate, NgbInputDatepicker } from '@ng-bootstrap/ng-bootstrap';
import {
  EnterpriseSearchService,
  WithSubscriptionComponent
} from '@sabstravtech/obtservices/angular';

import { DeviceDetector } from '../../services/device-detector.service';

@Component({
  selector: 'app-datepicker',
  templateUrl: './datepicker.component.html',
  styleUrls: ['./datepicker.component.scss'],
  standalone: false
})
export class DatepickerComponent extends WithSubscriptionComponent implements OnInit {
  @Input() minDate: NgbDate;
  @Input() startDate: NgbDate;
  @Input() model: NgbDate;
  @Input() componentId: string;
  @Input() formControlName = 'name';
  @Input() class: string;
  @Input() disabled: boolean;
  @Input() required = false;
  @Input() maxDate: NgbDate;
  @Input() from: NgbDate;
  @Input() to: NgbDate;
  @Input() isFormRangeFrom = false;
  @Input() isFormRangeTo = false;
  @Output() newDate: EventEmitter<NgbDate> = new EventEmitter();
  @Output() newFrom: EventEmitter<NgbDate> = new EventEmitter();
  @Output() newTo: EventEmitter<NgbDate> = new EventEmitter();
  previousValue: { day: number; month: number; year: number };

  hoveredDate: NgbDate | null = null;

  constructor(
    public deviceDetector: DeviceDetector,
    private searchService: EnterpriseSearchService
  ) {
    super();
  }

  ngOnInit() {}

  emit(newDate: any): void {
    if (!newDate) {
      return;
    }

    if (typeof newDate === 'string') {
      return;
    } // ! - Prevents incomplete dates from being emitted - in conjunction with custom-ngb-date-parser-formatter

    let date: NgbDate;

    if (newDate.year) {
      date = <NgbDate>{
        day: newDate.day,
        month: newDate.month,
        year: newDate.year
      };
    } else {
      try {
        // check the length of the string 31/12/22 - 8 chars, 31/12/2022 - 10 chars
        const split = newDate.split('/');
        if (newDate.length === 8) {
          date = <NgbDate>{
            day: Number(split[0]),
            month: Number(split[1]),
            year: Number(split[2]) + 2000
          };
        } else if (newDate.length === 10) {
          date = <NgbDate>{
            day: Number(split[0]),
            month: Number(split[1]),
            year: Number(split[2])
          };
        }
      } catch (error) {
        console.error(error);
      }
    }
    this.newDate.emit(date);
  }

  dateSelect(event: NgbDate) {
    if (event) {
      this.searchService.loadingDate.next(true);

      this.emit(event);
      setTimeout(() => {
        this.searchService.loadingDate.next(false);
      }, 900);
    }
  }

  onDateSelection(date: NgbDate, datePicker: NgbInputDatepicker) {
    if (!this.from && !this.to) {
      this.from = date;
    } else if (this.from && !this.to && (date.after(this.from) || date.equals(this.from))) {
      this.to = date;
      datePicker.close();
    } else {
      this.to = null;
      this.from = date;
    }
    if (this.isFormRangeFrom) {
      setTimeout(() => {
        this.model = this.from;
      }, 0);
    } else if (this.isFormRangeTo) {
      setTimeout(() => {
        this.model = this.to;
      }, 0);
    }
    this.newFrom.emit(this.from);
    this.newTo.emit(this.to);
  }

  isHovered(date: NgbDate) {
    return (
      this.from &&
      !this.to &&
      this.hoveredDate &&
      date.after(this.from) &&
      date.before(this.hoveredDate)
    );
  }

  isInside(date: NgbDate) {
    return this.to && date.after(this.from) && date.before(this.to);
  }

  isRange(date: NgbDate) {
    return (
      date.equals(this.from) ||
      (this.to && date.equals(this.to)) ||
      this.isInside(date) ||
      this.isHovered(date)
    );
  }

  isFrom(date: NgbDate) {
    return date.equals(this.from);
  }

  isTo(date: NgbDate) {
    return date.equals(this.to);
  }
}
